import CryptoJS from "crypto-js";

// Define your encryption key and IV
const key = CryptoJS.enc.Utf8.parse("wYn8wmfh4GCA0alTCSwTeudfxtsxabhO"); // 32 characters, 256 bits
const iv = CryptoJS.enc.Utf8.parse("kQIuOmps0MnNcMFl"); // 16 characters, 128 bits

// Decrypt function for UserData
export function decrypt(encryptedData) {
  try {
    const decrypted = CryptoJS.AES.decrypt(encryptedData, key, { iv: iv });
    const decryptedString = decrypted.toString(CryptoJS.enc.Utf8);
    // If decryption was successful, parse the JSON string
    if (decryptedString) {
      return JSON.parse(decryptedString);
    }

    // If the decrypted string is empty or null, return null
    return null;
  } catch (error) {
    console.error("Decryption failed:", error);
    return null;
  }
}
